import { TENANT_ID_SET } from "../actions/tenantId";
import types from "../actionsIndex";

// Add the whitelisted actions here
// All whitelisted actions will be persisted to local storage and loaded the next time app is started
const whitelist = {
  [types.settings.CHANGE_THEME]: true,
  [TENANT_ID_SET]: true,
};

export function shouldPersistAction(type: string) {
  return whitelist[type] || false;
}
